const GA_MEASUREMENT_ID = "G-C02B1PQM15";

export const trackLogin = (userId) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "login", { method: "email" });
    if (userId) {
      window.gtag("config", GA_MEASUREMENT_ID, {
        user_id: String(userId),
      });
    }
  }
};

export const setUserId = (userId) => {
  if (typeof window !== "undefined" && window.gtag && userId) {
    window.gtag("config", GA_MEASUREMENT_ID, {
      user_id: String(userId),
    });
  }
};
